import { render, staticRenderFns } from "./ReceptionistDashboard.vue?vue&type=template&id=1c5f143e"
import script from "./ReceptionistDashboard.vue?vue&type=script&lang=js"
export * from "./ReceptionistDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReceptionistDashboard.vue?vue&type=style&index=0&id=1c5f143e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports